import { useFDCNotificationsContext } from '../../../../../../../../FDCNotificationsContext'
import { ConcurrenceLevelsFormItemProps, ConcurrenceLevel } from './types'
import { useState } from 'react'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import { LabeledValueType } from 'components/CIMSSelect/types'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSCollapse from 'components/CIMSCollapse'
import GroupFallback from '../../../../../../../../components/GroupFallback'
import { alphabeticalSort } from '@cims-online/shared'

const ConcurrenceLevelsFormItem: React.FC<ConcurrenceLevelsFormItemProps> = ({
  onChange,
  value,
}) => {
  const { data } = useFDCNotificationsContext()
  const [values, setValues] = useState<Map<string, ConcurrenceLevel>>(
    (value ?? []).reduce(
      (map, v) => map.set(v.concurrenceLevelId, v),
      new Map<string, ConcurrenceLevel>()
    )
  )
  const change = (id: string, recipients: LabeledValueType[]) =>
    setValues((prev) => {
      const map = new Map(prev)
      map.set(id, { concurrenceLevelId: id, recipients })
      onChange?.([...map.values()])
      return map
    })
  return (
    <CIMSCollapse
      noPanelsContent={<GroupFallback group="Concurrence Levels" />}
      panels={(data?.fdcConcurrenceLevels ?? [])
        .sort(alphabeticalSort('name'))
        .map(({ id, name, description }) => {
          return {
            key: id,
            header: {
              type: 'described',
              name,
              description,
            },
            children: (
              <CIMSFormItem label="Recipients">
                <RecipientsSelect
                  value={values.get(id)?.recipients ?? []}
                  onChange={(recipients) =>
                    change(id, recipients as LabeledValueType[])
                  }
                />
              </CIMSFormItem>
            ),
          }
        })}
    />
  )
}

export default ConcurrenceLevelsFormItem
